"use client";

import { useState } from "react";
import { useLocation } from "wouter";
import { useOnboardingStore } from "../../lib/onboarding";

const MIN_CHAR_COUNT = 10;

const OnboardingStep5 = () => {
  const [, setLocation] = useLocation();
  const { goalsText, setGoalsText } = useOnboardingStore();
  const [touched, setTouched] = useState(false);

  const handleNext = () => {
    setTouched(true);
    if (!goalsText.trim() || goalsText.trim().length < MIN_CHAR_COUNT) {
      return;
    }
    setLocation("/onboarding/step-6");
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-slate-900 font-display">What are you working towards right now?</h2>
        <p className="mt-2 text-slate-600">Share the top ambitions or milestones you want a coach to help you unlock.</p>
      </div>

      <div className="space-y-2">
        <label htmlFor="goals" className="block text-sm font-medium text-slate-700 font-sans">Your goals</label>
        <textarea
          id="goals"
          value={goalsText}
          onChange={(event) => setGoalsText(event.target.value)}
          rows={6}
          className="mt-1 w-full rounded-md border border-input bg-white px-4 py-3 text-base text-slate-900 shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 font-sans"
          placeholder="E.g. Craft a promotion plan for the next review cycle, build a calmer weekly ritual, step up in stakeholder meetings..."
        />
        {touched && (!goalsText.trim() || goalsText.trim().length < MIN_CHAR_COUNT) && (
          <p className="text-sm text-red-600">Give us a bit more detail so we can set you up with the right coach.</p>
        )}
      </div>

      <div className="flex justify-between pt-4">
        <button
          type="button"
          onClick={() => setLocation("/onboarding/step-4")}
          className="inline-flex items-center justify-center px-6 py-2 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary font-display"
        >
          Back
        </button>
        <button
          type="button"
          onClick={handleNext}
          className="inline-flex items-center justify-center px-6 py-2 border border-transparent text-base font-medium rounded-md shadow-sm bg-accent !text-white hover:bg-accent/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-accent disabled:opacity-50 font-display"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default OnboardingStep5;
